var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAustralia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#061b65",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m5.84 14.74.53 1.67 1.64-.62-.97 1.45 1.5.9-1.74.15.24 1.73-1.2-1.27-1.2 1.27.23-1.73-1.74-.15 1.5-.9-.96-1.45 1.63.62zm16.27 3.01.3.91.88-.34-.52.8.82.48-.95.08.13.95-.66-.7-.65.7.13-.95-.95-.08.82-.48-.53-.8.9.34zm-2.94-8.62.29.9.89-.33-.53.79.82.48-.95.09.13.94-.65-.69-.66.69.13-.94-.95-.09.82-.48-.53-.8.9.34zm3.26-6 .3.9.88-.33-.53.79.82.48-.95.09.14.94-.66-.69-.66.69.14-.94-.95-.08.82-.5-.53-.78.89.33zm4.7 3.69.3.9.88-.33-.52.79.82.48-.95.09.13.94-.66-.69-.65.69.13-.94-.95-.09.82-.48-.53-.8.9.34zM24.74 12l.23.56.61.05-.47.4.15.59-.52-.33-.52.33.15-.6-.47-.39.61-.04zM5.5 9.77V12h4V9.77L12.54 12H15v-1.24L11.24 8H15V4h-2.74L15 2V0h-1.44L9.5 2.98V0h-4v2.8L1.75 0H0v1.9L2.99 4H0v4h3.76L0 10.76V12h2.46z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d22d32",
    d: "m0 1 4.09 3h1.36L0 0zm0 11 5.45-4v1l-4.09 3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d22d32",
    d: "M8.5 12h-2V7H0V5h6.5V0h2v5H15v2H8.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#d22d32",
    d: "M15 11.67 10 8v1l4.1 3h.9zM15 0h-.25L9.3 4h1.37L15 .82z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustralia);
export default __webpack_public_path__ + "static/media/australia.60d12812c52bac18df0ba4adeb2bd6e8.svg";
export { ForwardRef as ReactComponent };